
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, class_type, anonRecord_type, list_type, record_type, option_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, BusinessUnitId_$reflection, RequestedValue$1_$reflection, FormKind_$reflection, FormState_$reflection } from "../../Shared/Shared.js";
import { BusinessUnitDetailDto_$reflection, BusinessUnitOverviewDto_$reflection } from "../../Shared/BusinessUnit.js";

export class FormValues extends Record {
    constructor(Name, Description, SelectedParentBusinessUnitId, ImageUrl) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.SelectedParentBusinessUnitId = SelectedParentBusinessUnitId;
        this.ImageUrl = ImageUrl;
    }
}

export function FormValues_$reflection() {
    return record_type("BusinessUnit.Form.Types.FormValues", [], FormValues, () => [["Name", string_type], ["Description", string_type], ["SelectedParentBusinessUnitId", option_type(string_type)], ["ImageUrl", option_type(string_type)]]);
}

export class State extends Record {
    constructor(FormState, FormKind, Form, BusinessUnitId, BusinessUnits) {
        super();
        this.FormState = FormState;
        this.FormKind = FormKind;
        this.Form = Form;
        this.BusinessUnitId = BusinessUnitId;
        this.BusinessUnits = BusinessUnits;
    }
}

export function State_$reflection() {
    return record_type("BusinessUnit.Form.Types.State", [], State, () => [["FormState", FormState_$reflection()], ["FormKind", FormKind_$reflection()], ["Form", RequestedValue$1_$reflection(FormValues_$reflection())], ["BusinessUnitId", option_type(BusinessUnitId_$reflection())], ["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetName", "SetDescription", "SetParentBusinessUnit", "SaveBusinessUnit", "BusinessUnitSaved", "BusinessUnitFetched", "BusinessUnitsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("BusinessUnit.Form.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", BusinessUnitOverviewDto_$reflection()]))]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", BusinessUnitDetailDto_$reflection()]], [["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

